import React from 'react';
import { Container } from '@mui/material';
import SplitScroll, { ISplitScrollProps } from '../../Feed/SplitScroll';

interface IFeedLayerProps extends ISplitScrollProps {}

const FeedContainer: React.FC<IFeedLayerProps> = props => {
    return (
        <Container
            disableGutters
            maxWidth={false}
            style={{
                height: '100vh',
                display: 'flex',
                alignItems: 'flex-start',
                flexDirection: 'column',
                justifyContent: 'flex-start',
            }}
            sx={{
                width: '100%',
                marginTop: { xs: '0', sm: '20px', md: 0 },
                marginLeft: { xs: '0px', sm: '65px', xl: '100px' },
                paddingLeft: { xs: '0', md: '40px' },
                paddingRight: { xs: '0', md: '0px' },
            }}>
            <SplitScroll {...props} />
        </Container>
    );
};

export { FeedContainer };
